import { Type } from 'class-transformer';
import { IsIn, IsNotEmptyObject, IsOptional, IsString, ValidateIf, ValidateNested } from 'class-validator';

import { NotificationSubscriptionsDto } from '../notifications';
import { WEB_VERSION, WebVersion } from './web-version.constants';

export class UserPreferencesDto {
  @IsOptional()
  @IsString()
  locale?: string;

  @IsOptional()
  @IsString()
  theme?: string;

  /** Notification category toggles, including `orderShipment` and `orderUpdates`. */
  @ValidateIf((_, value) => value !== undefined)
  @IsNotEmptyObject()
  @ValidateNested()
  @Type(() => NotificationSubscriptionsDto)
  subscriptions?: NotificationSubscriptionsDto;

  @IsOptional()
  @IsIn(Object.values(WEB_VERSION))
  webVersionPreference?: WebVersion | null;
}
